/**
 * @copyright 2023 Chris Zuber <admin@kernvalley.us>
 */
export const TEXT = 'text/plain';
export const HTML = 'text/html';
export const CSS = 'text/css';
export const JS = 'application/javascript';
export const JSON = 'application/json';
export const XML = 'application/xml';
export const JSON_LD = 'application/ld+json';
export const JPEG = 'image/jpeg';
export const PNG = 'image/png';
export const GIF = 'image/gif';
export const WEBP = 'image/webp';
export const SVG = 'image/svg+xml';
export const FORM_URL_ENCODED = 'application/x-www-form-urlencoded';
export const FORM_MULTIPART = 'multipart/form-data';
